import { combineReducers } from 'redux';
// Import reducers
import table from './documents_panel_reducer';
import form from './documents_form_reducer';

export default combineReducers({
	table,
	form
});
